import DebugUANC from '../core/version/debug';

interface ICookieParams {
    name: string;
    value: string | boolean;
    days: number;
    path?: string;
}

export const isCookiesEnabled = (): boolean => {
    let isCookiesEnabled = navigator.cookieEnabled;

    if (!isCookiesEnabled) {
        document.cookie = 'UANC-test-cookies; SameSite=Strict';
        const cookiesEnabledByTest = document.cookie.indexOf('UANC-test-cookies') !== -1;

        if (cookiesEnabledByTest) {
            document.cookie = 'UANC-test-cookies; SameSite=Strict; expires=Thu, 01 Jan 1970 00:00:00 GMT';
            isCookiesEnabled = true;
        }
    }

    return isCookiesEnabled;
};

export const setCookie = (cookieParams: ICookieParams): void => {
    try {
        const { name, value, days } = cookieParams;
        const path = cookieParams.path ?? '/';
        let expires = '';

        if (!isCookiesEnabled) return;
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = `; expires=${date.toUTCString()}`;
        }

        document.cookie = `${name}=${encodeURIComponent(value) || ''}${expires}; path=${path}`;
    } catch (e) {
        window.Inpl?.Ad?.UANC && window.Inpl.Ad.UANC instanceof DebugUANC && window.Inpl.Ad.UANC.info('set', e);
    }
};

export const getCookie = (name: string): string | null => {
    try {
        if (!isCookiesEnabled || !name) return null;

        return document.cookie.split('; ').reduce((r: null | string, v: string) => {
            const parts = v.split('=');
            return parts[0] === name ? decodeURIComponent(parts[1]) : r;
        }, null);
    } catch (e) {
        window.Inpl?.Ad?.UANC && window.Inpl.Ad.UANC instanceof DebugUANC && window.Inpl.Ad.UANC.info('get', e);
        return null;
    }
};

export const deleteCookie = (name: string): void => {
    try {
        if (!isCookiesEnabled) return;

        setCookie({ name, value: '', days: -1 });
    } catch (e) {
        window.Inpl?.Ad?.UANC && window.Inpl.Ad.UANC instanceof DebugUANC && window.Inpl.Ad.UANC.info('delete', e);
    }
};
